import React from "react";
import { twMerge } from "tailwind-merge";

type ChipProps = {
  active?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

function Chip({ active = false, className, children, ...rest }: ChipProps) {
  return (
    <button
      type="button"
      className={twMerge(
        "inline-flex items-center gap-1 rounded-full px-3 py-1 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap",
        active
          ? "bg-ink-primary text-surface-card"
          : "bg-surface-inset text-ink-secondary hover:bg-surface-raised",
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Chip;
